module.exports = __webpack_public_path__ + "static/img/200094.86f08fd9.png";